module.exports = __webpack_public_path__ + "img/img(7).7f697dd4.png";